import React, { useCallback, useEffect, useMemo, useState } from "react";
import CreatableAsyncSelect from 'react-select/async-creatable';
import { apiRequest } from "../../../../hooks/apiRequest";
import { debounce } from "lodash";
import { objectToFormData } from "../../../../utils/helpers";

const MotivoSelect = ({value, disabled, onChange, tipo}) => {
    const getMotivoOptions = async (search) => {
        return (await apiRequest({}, `salud/motivos?buscar=${search}&tipo=${tipo ?? ''}`, 'get')).data;
    };

    const loadOptions = useMemo(() => debounce((inputValue, callback) => {
        getMotivoOptions(inputValue).then(data => callback(data));
    }, 500), [tipo]);

    const handleCreate = async (descripcion) => {
        const { data } = await apiRequest(objectToFormData({descripcion, tipo}), `salud/motivos`, 'post');

        const option = {
            ...data,
            value: data.id,
            label: data.descripcion
        };

        onChange(option);
    };

    return <CreatableAsyncSelect
        key={tipo}
        name="motivo"
        isClearable
        cacheOptions
        placeholder="Buscar o crear motivo"
        defaultOptions
        loadOptions={loadOptions}
        onCreateOption={handleCreate}
        onChange={onChange}
        value={value}
        isDisabled={disabled}
    />;
};

export default MotivoSelect;